@if (seasonData ) {
  <div>
    <div class="row orders_rowsection">
    <div class="col-xs-12 orders_newordertitle">{{"ordersummary.newordertxt" | cxTranslate}}</div>
    @if(seasonData.preSeason != ''){
    <div class="col-xs-12 orders_neworderbox-preSeason" >
        <a class="anchorunderline" routerLink="/start-order">
            <div class="orders_boxtext1">{{"ordersummary.reservefortxt" | cxTranslate}}</div>
            <div class="orders_boxtext2" >{{seasonData.preSeason}} {{"ordersummary.seasontxt" | cxTranslate}}<i class="orders_global_blackarrow pull-right"></i>
                </div>
            </a>
            
</div>
    }
    <div class="col-xs-12 orders_neworderbox2">
                <a class="anchorunderline" routerLink="/start-order">
                    <div class="orders_boxtext1">{{"ordersummary.orderfortxt" | cxTranslate}}</div>
                    <div class="orders_boxtext2" >{{seasonData.inSeason}} {{"ordersummary.seasontxt" | cxTranslate}}<i class="orders_global_blackarrow pull-right"></i>
                        </div>
                    </a>
                   
</div>
@if (orderSummary | async; as item1 ) {
  <div class="row orders_rowsection borderClass ">
    <div class="row prodClass">
      <div class="col-xs-12 col-md-12 orders_producttitle">{{"ordersummary.productavailablity" | cxTranslate}}</div>
      <div class="col-xs-12 col-md-12 orders_productyear">{{seasonData.inSeason}}</div>
    </div>
    <div class="col-xs-12 orders_prodbox" >
      <div class="">
        <div class="col-xs-12 orders_prodtext1">{{"ordersummary.fluadlabel" | cxTranslate}}</div>
        @for (details of getProductsArray2(item1); track details) {
          <div>
            <div  class="col-xs-7 orders_prodtext2">{{details.presentationName}}</div>
            @if (details.sellable) {
              <span class="col-xs-5 orders_avilabletxt pull-right">{{"ordersummary.availabletxt" | cxTranslate}}</span>
            }
            @if (!details.sellable) {
              <span class=" col-xs-5 orders_soldouttxt pull-right">{{"ordersummary.soldouttxt" | cxTranslate}}</span>
            }
          </div>
        }
      </div>
      <div class="productClass">
        <div class="col-xs-12 orders_prodtext1">{{"ordersummary.flucelvaxlabel" | cxTranslate}}</div>
        @for (details of getProductsArray1(item1); track details) {
          <div>
            <div  class="col-xs-7 orders_prodtext2">{{details.presentationName}}</div>
            @if (details.sellable) {
              <span class="col-xs-5 orders_avilabletxt pull-right">{{"ordersummary.availabletxt" | cxTranslate}}</span>
            }
            @if (!details.sellable) {
              <span class=" col-xs-5 orders_soldouttxt pull-right">{{"ordersummary.soldouttxt" | cxTranslate}}</span>
            }
          </div>
        }
      </div>
      <!-- <div class="productClass2">
      <div class="col-xs-12 orders_prodtext1">{{"ordersummary.aflurialabel" | cxTranslate}}</div>
      <div *ngFor="let details of getProductsArray3(item1)">
        <div  class="col-xs-7 orders_prodtext2">{{details.presentationName}}</div>
        <span *ngIf="details.sellable" class="col-xs-5 orders_avilabletxt pull-right">{{"ordersummary.availabletxt" | cxTranslate}}</span>
        <span *ngIf="!details.sellable" class=" col-xs-5 orders_soldouttxt pull-right">{{"ordersummary.soldouttxt" | cxTranslate}}</span>
      </div>
    </div> -->
  </div>
</div>
}
<!-- <div class="product-availability">
<h3>Product Availability</h3>
<p class="item">{{item.inSeason}}</p>
<ul>
  <li>
    <div class="orders">FLUAD®</div>
    <span class="orders_prodtext2">0.5-mL pre-filled syringe</span>
    <span class="availability pull-right">AVAILABLE</span>
  </li>
  <li>
    <div class="orders">FLUCELVAX®</div><br />
    <span class="orders_prodtext2">0.5-mL pre-filled syringe</span><span class="availability pull-right">AVAILABLE</span><br/>
    <span class="orders_prodtext2">5-mL multi-dose vial</span> <span class="orders_soldout pull-right">SOLD OUT</span>
  </li>
  <li>
    <div class="orders">AFLURIA®</div><br />
    <span class="orders_prodtext2">0.5-mL pre-filled syringe</span> <span class="availability pull-right">AVAILABLE</span>
    <br/>
    <span class="orders_prodtext2">5-mL multi-dose vial</span> <span class="availability pull-right">AVAILABLE</span>
  </li>
</ul>
</div> -->
</div>
</div>
}




